import{jsx as e,jsxs as t}from"react/jsx-runtime";import"react";import{twMerge as i}from"tailwind-merge";import{Box as r}from"../../Base/Layouts/Box/Box.js";import{SIZES as a,generateBoxSize as o}from"./LoadingIndicator.parts.js";
/**
 * 로딩 상태를 표시하는 애니메이션 인디케이터 컴포넌트입니다.
 * 세 개의 점이 순차적으로 페이드 인/아웃되는 애니메이션을 보여줍니다.
 *
 * @param {Object} props - 컴포넌트 프로퍼티
 * @param {boolean} [props.isFixed=false] - true일 경우 position: fixed, false일 경우 position: absolute로 설정됩니다.
 * @param {('sm'|'md'|'lg')} [props.size='md'] - 로딩 인디케이터의 크기를 설정합니다.
 * @param {string} [props.className] - 추가적인 CSS 클래스를 적용할 수 있습니다.
 *
 * @example
 * // 기본 사용
 * <LoadingIndicator />
 *
 * // 고정 위치에 큰 크기로 표시
 * <LoadingIndicator isFixed size="lg" />
 *
 * // 커스텀 클래스 적용
 * <LoadingIndicator className="text-blue-500" />
 */const n=({isFixed:n=!1,size:c="md",className:l})=>{const{width:s,height:d,viewBox:m,circle:u,r:p}=a[c];/*#__PURE__*/
return e(r,{role:"loading-indicator",className:i("left-1/2 top-1/2 aspect-square -translate-x-1/2 -translate-y-1/2",n?"fixed":"absolute",o(c)),children:/*#__PURE__*/t("svg",{xmlns:"http://www.w3.org/2000/svg",role:"loading-indicator--dots",width:s,height:d,viewBox:m,fill:"none",className:i("text-primary",l),children:[
/*#__PURE__*/e("circle",{cx:u[0],cy:u[1],r:p,fill:"currentColor",children:/*#__PURE__*/e("animate",{attributeName:"opacity",values:"1; 1; 0.5; 0.25; 0.25;",dur:"0.9s",repeatCount:"indefinite",begin:"0s"})}),
/*#__PURE__*/e("circle",{cx:u[1],cy:u[1],r:p,fill:"currentColor",children:/*#__PURE__*/e("animate",{attributeName:"opacity",values:"1; 1; 0.5; 0.25; 0.25;",dur:"0.9s",repeatCount:"indefinite",begin:"0.3s"})}),
/*#__PURE__*/e("circle",{cx:u[2],cy:u[1],r:p,fill:"currentColor",children:/*#__PURE__*/e("animate",{attributeName:"opacity",values:"1; 1; 0.5; 0.25; 0.25;",dur:"0.9s",repeatCount:"indefinite",begin:"0.6s"})})]})})};export{n as LoadingIndicator};
